module.exports = __webpack_public_path__ + "img/gard_vertical_1.ca7b8d4d.png";